import { isDiscriminatedProps, toDiscriminatedProps, } from '@famly/vet_apollo-utils';
import { cacheVariablesIsTransform } from './cache-variable-is-transform';
export function updateApolloCache() {
    return function _typeInferredFunction(outerProps) {
        const props = isDiscriminatedProps(outerProps) ? outerProps : toDiscriminatedProps(outerProps);
        return function (cache, result) {
            if (!result.data) {
                return;
            }
            const variables = (() => {
                if (!props.cacheVariables) {
                    return undefined;
                }
                if (cacheVariablesIsTransform(props.cacheVariables)) {
                    return props.cacheVariables(result.data);
                }
                return props.cacheVariables;
            })();
            let cachedData = null;
            try {
                cachedData = (props.type === 'query'
                    ? cache.readQuery({
                        query: props.node,
                        variables,
                    })
                    : cache.readFragment({
                        fragment: props.node,
                        id: props.id,
                        variables,
                    }));
            }
            catch (e) {
                // No cache available
            }
            const writeCache = (data) => {
                if (props.type === 'query') {
                    cache.writeQuery({
                        query: props.node,
                        variables,
                        data: data,
                    });
                }
                else {
                    cache.writeFragment({
                        fragment: props.node,
                        id: props.id,
                        variables,
                        data: data,
                    });
                }
            };
            switch (props.emptyCacheStrategy) {
                case 'allow-optional-cache':
                    writeCache(props.updater(cachedData, result.data));
                    break;
                default:
                    if (!cachedData) {
                        return;
                    }
                    writeCache(props.updater(cachedData, result.data));
            }
        };
    };
}
